const locale = {
  general: {
    language: 'Deutsch',
    cancel: 'Abbrechen',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    apply: 'Anwenden',
    continue: 'Fortfahren',
    confirm: 'Verstanden',
    save: 'Sparen',
    close: 'Schließen',
    loading: 'Laden, bitte warten ...\n',
    errorHeader: 'Fehler',
    errorEmptyField: 'Pflichtfeld',
    errorEmptyFields: 'Pflichtfeld ist leer',
    errorInvalidEmail: 'Ungültige E-Mail-Adresse',
    successHeader: 'Erfolgreich',
    successfullySaved: 'Erfolgreich gespeichert',
    successfullyVerified: 'Erfolgreich verifiziert',
    errorStampUpload: 'Stempel-Upload-Fehler'
  },
  oneTwoBuildNotifySales: {
    text: '12Build-Integration nicht aktiviert. Wenden Sie sich zur Aktivierung an Ihren Standort-Betreuer.'
  },
  treeView: {
    rootFolderName: 'Büro',
    title: 'Ordner',
    allFolder: 'Alle Ordner',
    favoriteFolder: 'Lieblingsordner',
    newDocs: 'Neue Dokumente',
    workBox: 'Arbeitsbox',
    newDocsDescription: 'Dokumente der letzten 7 Tage'
  },
  toolbar: {
    new: 'Neu',
    import: 'Dokument importieren',
    newViaTemplate: 'Neues Dokument aus Vorlage',
    expected: 'Erwartete Dokumente\n',
    newFolder: 'Neuer Ordner',
    newFolderViaTemplate: 'Neuer Ordner der Vorlage',
    show: 'Ansehen',
    edit: 'Zu ändern',
    publish: 'Publizieren',
    search: 'Suchen',
    status: 'Status',
    stamp: 'Stempeln',
    QRCode: 'QR-Code',
    message: 'Bericht',
    printOrder: 'Reproauftrag',
    version: 'Versionsbildschirm',
    view: 'Bild',
    extra: 'Extra'
  },
  mainNav: {
    documents: 'Dokumente',
    management: 'Verwaltung',
    messages: 'Berichte',
    contacts: 'Kontakte',
    procedures: 'Verfahren'
  },
  login: {
    username: 'Benutzername',
    usernameWithEmail: 'E-mail',
    password: 'Passwort',
    login: 'Anmelden',
    or: 'oder',
    back: 'Zurück',
    employeeOf: 'Mitarbeiter von Pro4all',
    portal: 'Pro4All-Portal',
    reset: 'Passwort zurücksetzen',
    resetText: 'Geben Sie Ihr neues Passwort ein.',
    resetBadPassFirst: 'Das angegebene Passwort ist ungültig. Das Passwort darf vorher nicht verwendet worden sein, muss mindestens aus ',
    resetBadPassSecond: 'Zeichen bestehen und muss ',
    resetBadPassThird: 'nicht-alphanumerische Zeichen enthalten.',
    resetDiffer: 'Die Passwörter stimmen nicht überein.',
    resetSave: 'Speichern',
    resetNew: 'Neues Passwort',
    resetConfirm: 'Passwort bestätigen',
    resetSuccess: 'Das Passwort wurde festgelegt. Gehen Sie zurück und melden Sie sich mit Ihrem neuen Passwort an.',
    resetFail: 'Der Link ist falsch oder nicht mehr gültig',
    forgotPassword: 'Passwort vergessen?',
    forgotPasswordText: 'Geben Sie Ihren Benutzernamen ein, um ein neues Passwort zu erhalten',
    forgotPasswordTextWithEmail: 'Geben Sie Ihre E-Mail-Adresse ein, um ein neues Passwort zu erhalten',
    forgotPasswordFail: 'Kein Benutzername angegeben',
    forgotPasswordFailEmail: 'Ungültiges E-Mail-Format angegeben',
    forgotPasswordSuccessFirst: 'Wenn der angegebene Benutzername in Docstream vorhanden ist, sollten Sie eine E-Mail mit einem Link zum Zurücksetzen des Passwort erhalten. Diese Aktion kann bis zu ',
    forgotPasswordSuccessFirstWithEmail: 'Wenn die angegebene E-Mail in Docstream vorhanden ist, sollten Sie eine E-Mail mit einem Link zum Zurücksetzen des Kennworts erhalten. Diese Aktion kann bis zu ',
    forgotPasswordSuccessSecond: 'Mal am Tag ausgeführt werden.',
    forgotPasswordSuccessTimeFirst: 'Bitte beachten Sie, dass der gesendete Link nur für ',
    forgotPasswordSuccessTimeSecond: 'Minuten gültig ist.',
    expired: 'Ihre Sitzung ist abgelaufen',
    expiredText: 'Die Sitzung ist aufgrund Ihrer Inaktivität in Docstream abgelaufen. Drücken Sie die Taste unten, um sich erneut anzumelden.',
    doubleLogin: 'Benutzername bereits angemeldet!',
    doubleLoginFirstHeader: 'Ursache:',
    doubleLoginFirstText: 'Die Ursache für diese Meldung ist, dass Sie bereits auf einem anderen Computer mit denselben Benutzerdaten angemeldet sind.',
    doubleLoginSecondHeader: 'Lösung:',
    doubleLoginSecondText: 'Speichern Sie zuerst Ihren Fortschritt auf dem anderen Computer, melden Sie sich dort ab und wieder an.',
    wrongLoginTitle: 'Anmeldung fehlgeschlagen',
    wrongLogin: 'Überprüfen Sie die Zugangsdaten und versuchen Sie es erneut',
    wrongEmailFormat: 'Ungültiges E-Mail-Format',
    wrongEmail: 'Eine gültige E-Mail-Adresse eingeben',
    loginRequestError: 'Beim Anmelden ist ein Problem aufgetreten.',
    introText: 'Verwalten Sie alle Ihre Projekte und Dokumente an einem Ort',
    send: 'E-Mail senden',
    loggedOut: 'Sie sind abgemeldet.',
    loggedOutText: 'Sie sind von Docstream abgemeldet. Drücken Sie die Taste unten, um sich erneut anzumelden.',
    OIDCErrorHeader: 'Anmeldung fehlgeschlagen',
    OIDCErrorFirstText: 'Wir konnten Sie nicht mit Ihrem externen Konto anmelden. Möglicherweise haben Sie kein externes Konto eingerichtet.',
    OIDCErrorSecondText: 'Um Ihr externes Konto einzurichten, melden Sie sich mit Ihren Docstream-Zugangsdaten an und konfigurieren Sie Ihr externes Konto unter [Extras -> Externes Konto].',
    mfaTitle: 'Verifizieren Sie Ihr Konto',
    mfaDescription: 'Den zweistufigen Bestätigungscode finden Sie in der Authentifizierungs-App.',
    mfaPlaceholder: 'Geben Sie den Code ein',
    mfaButton: 'Anmelden',
    mfaTitleSetup: 'Verifizieren Sie Ihr Konto',
    mfaDescriptionSetup: 'Authentifizierungs-App auf Ihrem Smartphone öffnen.',
    mfaTitleSetup2: 'Einfach scannen',
    mfaDescriptionSetup2: 'Scannen Sie den QR-Code in der Authentifizierungs-App auf Ihrem Smartphone.',
    mfaTitleSetup3: 'Geben Sie den Code ein',
    mfaDescriptionSetup3: 'Geben Sie hier die sechs Ziffern ein, die in der Authentifizierungs-App angezeigt werden.',
    mfaDescriptionCode: 'Verwenden Sie den folgenden Code manuell:',
    mfaButtonSetup: 'Code bestätigen'
  },
  loginCarousel: {
    slideTitle: 'Lernen Sie Prostream kennen',
    slideText: 'Die neueste Art, Dokumente und Projekte zu verwalten. {slideLinkText} für weitere Informationen.',
    slideLinkText: 'Klicken Sie hier'
  },
  newFolder: {
    title: 'Neuen Ordner erstellen',
    subTitle: 'Ordnernamen',
    inputText: 'Ordnernamen angeben',
    cancelButton: 'Abbrechen',
    acceptButton: 'OK',
    errorMessage: 'Der Ordnername muss mindestens 1 Zeichen enthalten und darf maximal 255 Zeichen und keines der folgenden Zeichen enthalten: \\/:*?"<>|.'
  },
  usersInformation: {
    headerTitle: 'Benutzerinformation',
    tabs: {
      title: 'Einstellungen',
      general: 'Allgemeines',
      personalInformation: 'Persönliche Daten',
      companyInformation: 'Firmendaten',
      signature: 'Unterschrift',
      verify: '2-Faktor-Authentifizierung',
      stamp: 'Stempeln'
    },
    buttons: {
      close: 'Schließen',
      save: 'Speichern'
    },
    general: {
      title: 'Allgemeines',
      text: 'Geben Sie hier Ihre allgemeinen Einstellungen ein. Bitte beachten Sie, dass sich alle Anpassungen auf die gesamte Umgebung auswirken.',
      username: 'Benutzername',
      name: 'Name',
      email: 'E-Mail-Adresse',
      toInform: 'Zur Information',
      dropdownPlaceholder: 'Option auswählen...',
      dropdownOptions: ['Ja, alle Ordner', 'Ja, bestimmte Ordner', 'Nein', 'Ja, pro ausgewähltem Favoritenordner'],
      description: 'Beschreibung',
      password: 'Passwort',
      confirmPassword: 'Kennwort bestätigen',
      passwordChange: 'Anpassen',
      resetEmail: 'E-Mail zum Zurücksetzen senden'
    },
    personal: {
      title: 'Persönliche Daten',
      text: 'Geben Sie hier Ihre allgemeinen Einstellungen ein. Bitte beachten Sie, dass sich alle Anpassungen auf die gesamte Umgebung auswirken.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      prefixes: 'Präfixe',
      email: 'E-Mail-Adresse',
      workphone: 'Arbeitsnummer',
      mobile: 'Handynummer',
      checkbox: 'Ich möchte den Newsletter erhalten'
    },
    company: {
      title: 'Firmendaten',
      text: 'Geben Sie hier Ihre allgemeinen Einstellungen ein. Bitte beachten Sie, dass sich alle Anpassungen auf die gesamte Umgebung auswirken.',
      name: 'Firmenname',
      function: 'Standort'
    },
    signature: {
      title: 'Unterschrift',
      text: 'Ihre Unterschrift wird in der gesamten E-Mail-Korrespondenz verwendet.'
    },
    verify: {
      title: '2-Faktor-Authentifizierung',
      text1: 'Scannen Sie den QR-Code mit einer Zwei-Faktor-Authentifizierungs-App, um Ihr Konto zu sichern. Wenn Sie sich das nächste Mal anmelden, müssen Sie den Code aus der App verwenden, um zu bestätigen, dass Sie sich anmelden möchten.',
      text2: 'Sobald Sie diesen QR-Code gescannt haben, wird ein numerischer Code angezeigt. Geben Sie diesen Code ein und bestätigen Sie, um die App mit Ihrem Konto zu verbinden.',
      disabledText: 'Die 2-Faktor-Authentifizierung ist bereits aktiviert. Sie können diese deaktivieren oder den TOIP-Code suchen, um Ihr Konto freizugeben oder eine Verknüpfung zu einem \'Passwort-Tresor\' herzustellen.',
      confirm: 'Bestätigen',
      disable: 'deaktivieren'
    },
    stamp: {
      title: 'Stempeln',
      text: 'Add Stempeln',
      noImage: 'Kein Bild',
      upload: 'Hochladen',
      fileExtension: 'Nur .PNG-Bilder können als Stempel verwendet werden.'
    }
  },
  folderProperties: {
    general: {
      title: 'Allgemeines',
      form: {
        label1: 'Ordnername',
        label2: 'Ordner erstellt von',
        label3: 'Erstellungsdatum des Ordners',
        label4: 'Ordnerkapazität',
        label5: 'Metadatensatz',
        label6: 'Projekt',
        label7: 'Snagstream-Projekt',
        notLinked: 'Nicht verknüpft',
        checkbox1: 'Projektordner',
        checkbox2: 'Vertrauenswürdiger Ordner',
        unlinkButton: 'Verknüpfung aufheben'
      }
    },
    procedure: {
      title: 'Verfahren',
      form: {
        checkbox: 'Starten Sie automatisch ein neues Verfahren, wenn Sie ein Dokument (Version) platzieren',
        label1: 'Standard',
        label2: 'Inhaber'
      }
    },
    requiredDocuments: {
      title: 'Erforderliche Dokumente',
      form: {
        label: {
          line1: 'Geben Sie nachstehend die erforderlichen Dokumentnamen dieses Ordners ein',
          line2: '(Jeder Name in einer neuen Zeile)'
        },
        textareaPlaceholder: ''
      }
    }
  },
  folderRights: {
    header: {
      title: 'Berechtigungen am',
      searchPlaceholder: 'Suche...'
    },
    table: {
      header: {
        Name: {
          title: 'Name',
          bodyTitle: 'Information',
          bodyText: [
            'Einige Rechte haben zwei Spalten, eine Erläuterung dazu finden Sie unten',
            'Die erste Spalte zeigt die spezifischen Rechte für den aktuellen Ordner an.',
            'Die zweite Spalte zeigt an, dass die spezifische Berechtigung auch für Unterordner gilt.'
          ]
        },
        IL: {
          bodyTitle: 'Interner Leser',
          bodyText: [
            'Alle Dokumente sind sichtbar, ungeachtet des Status des Dokuments.'
          ]
        },
        EL: {
          bodyTitle: 'Externer Leser',
          bodyText: [
            'Genehmigte Dokumente sind sichtbar.'
          ]
        },
        DL: {
          bodyTitle: 'Endleser',
          bodyText: [
            'Dokumente mit Genehmigen- und Finalisieren-Status sind sichtbar.'
          ]
        },
        ET: {
          bodyTitle: 'Externes Teammitglied',
          bodyText: [
            'Genehmigen Dokumente sind sichtbar.',
            'Ihre eigenen Dokumente sind sichtbar.',
            'Sie können neue Dokumente speichern.',
            'Sie können neue Versionen bei Ihren eigenen Dokumenten speichern.',
            'Sie können Dokumenten den Status Genehmigen geben oder dies rückgängig machen.',
            'Sie können nur Ihre eigenen Dokumente löschen.'
          ]
        },
        A: {
          bodyTitle: 'Assistent',
          bodyText: [
            'Alle Dokumente sind sichtbar, ungeachtet des Status des Dokuments.',
            'Sie können neue Dokumente speichern.',
            'Sie können neue Versionen bei den Dokumenten speichern.',
            'Sie können nur Ihre eigenen Dokumente löschen.'
          ]
        },
        IT: {
          bodyTitle: 'Internes Teammitglied',
          bodyText: [
            'Alle Dokumente sind sichtbar, ungeachtet des Status des Dokuments.',
            'Sie können neue Dokumente speichern.',
            'Sie können Dokumente löschen.',
            'Sie können neue Versionen bei den Dokumenten speichern.',
            'Sie können Dokumenten den Status Genehmigen geben oder dies rückgängig machen.'
          ]
        },
        '+': {
          bodyTitle: 'Unterordner erstellen',
          bodyText: [
            'Sie können in diesem Ordner neue Ordner erstellen.'
          ]
        },
        EV: {
          bodyTitle: 'Endverantwortlicher',
          bodyText: [
            'Sie können Dokumenten den Status Finalisieren geben oder dies rückgängig machen.'
          ]
        },
        B: {
          bodyTitle: 'Verwalter',
          bodyText: [
            'Alle Dokumente sind sichtbar, ungeachtet des Status des Dokuments.'
          ]
        },
        PB: {
          bodyTitle: 'Kontakteadministrator',
          bodyText: [
            'Sie sind Kontaktverwalter.'
          ]
        },
        PC: {
          bodyTitle: 'Prozesskoordinator',
          bodyText: [
            'Sie können Vorgänge mit Dokumenten verknüpfen.'
          ]
        },
        I: {
          bodyTitle: 'Informieren',
          bodyText: [
            'Hier können Sie eine E-Mail-Benachrichtigung für aktuelle Ordner und Unterordner aktivieren.'
          ]
        },
        Alternate: {
          EL: {
            bodyText: '\'{0}\' Dokumente sind sichtbar.'
          },
          DL: {
            bodyText: 'Dokumente mit beiden \'{0}\' und Finalisieren-Status sind sichtbar.'
          },
          ET: {
            bodyText1: '\'{0}\' Dokumente sind sichtbar.',
            bodyText2: 'Ihre eigenen Dokumente sind sichtbar.',
            bodyText3: 'Sie können neue Dokumente speichern.',
            bodyText4: 'Sie können neue Versionen bei Ihren eigenen Dokumenten speichern.',
            bodyText5: 'Sie können Dokumenten den Status \'{0}\' geben oder dies rückgängig machen.',
            bodyText6: 'Sie können nur Ihre eigenen Dokumente löschen.'
          },
          IT: {
            bodyText1: 'Alle Dokumente sind sichtbar, ungeachtet des Status des Dokuments.',
            bodyText2: 'Sie können neue Dokumente speichern.',
            bodyText3: 'Sie können Dokumente löschen.',
            bodyText4: 'Sie können neue Versionen bei den Dokumenten speichern.',
            bodyText5: 'Sie können Dokumenten den Status \'{0}\' geben oder dies rückgängig machen.'
          },
          EV: {
            bodyText: 'Sie können Dokumenten den Status \'{0}\' geben oder diesen rückgängig machen.'
          },
          Default: 'Genehmigen',
          DefaultFinal: 'Einfrieren'
        }
      }
    },
    buttons: {
      cancel: 'Abbrechen',
      exchange: 'Austauschen',
      modify: 'Ändern',
      close: 'Schließen',
      save: 'Speichern',
      removeAll: 'Alles entfernen'
    }
  },
  CommentDialog: {
    downloadAttachmentTitle: '{0} Anhänge',
    closeButtonText: 'Schließen',
    downloadButton: 'Download ({0})',
    errorMessage: 'The files you requested are not available or you do not have access to them'
  },
  DocumentGrid: {
    noOptionsAvailable: 'No options available',
    EmptyFolder: 'No documents available',
    DocumentNotLoaded: 'Unable to retrieve documents',
    searchingFilters: 'Suchfilter',
    selectedDocuments: '({0} document(en) geselecteerd)',
    checkVersionError: 'Unable to check selected versions',
    loadingGridMessage: 'Wird geladen',
    LoadingErrorMessage: 'The current page could not be loaded, try again later or report the error',
    ApplyFilter: 'Filter anwenden',
    RemoveFilters: 'Filter entfernen',
    SearchAllFolders: 'in allen Ordnern suchen',
    ascending: 'Aufsteigend',
    descending: 'Absteigend',
    facetFilter: 'Suchen...',
    selectAll: 'Alles auswählen',
    deSelectAll: 'Auswahl aufheben'
  }
}

export default locale



// WEBPACK FOOTER //
// ./src/localization/locales/de.js